module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-attend-eb4a92a87101b196e9faf6ba22af9ae1.jpg";